"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = assert;
/**
 * v1's assert, without its console.error: the same Error, with the same
 * message, thrown silently.
 */
function assert(assertion, message) {
    if (!assertion) {
        throw new Error(`Assertion Failed: ${message}`);
    }
}
